import { Button, Card, Col, DatePicker, Form, Row, Select, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { API_METHODS, DEFAULT_DATE_FORMAT, REPORT_TYPES } from '../../constants';
import { formatDateToDayJS, getClientConfig, isEmpty } from '../../generalFunctions';
import useApi from '../../hooks/useApi';
import ReportPdfModal from '../common/ReportPdfModal';
import moment from 'moment';

const Report = (props) => {
    const [form] = Form.useForm();
    const [response, request] = useApi("/reports/dateRange", null, API_METHODS.POST);
    const [selectedType, setSelectedType] = useState();
    const [visiblePrint, setVisiblePrint] = useState(false);
    const [tableData, setTableData] = useState();
    const [processing, setProcessing] = useState(false);
    const { account } = getClientConfig();

    const handlePrint = () => {
        const flag = visiblePrint ? false : true;
        setVisiblePrint(flag);
    };

    useEffect(() => {
        if (response.data && !response.isLoading) {
            const tableData = !isEmpty(response.data) ? response.data : [];
            setTableData(tableData);
            setProcessing(false);
            handlePrint();
        }
    }, [response]);

    const onSubmit = () => {
        form.validateFields().then(values => {
            setProcessing(true);
            setSelectedType(values.reportType);
            values.startDate = formatDateToDayJS(values.startDate);
            values.endDate = formatDateToDayJS(values.endDate);
            request(values);
        });
    }

    const onClear = () => {
        setProcessing(false);
        form.resetFields();
    }

    const onChangeReportType = (reportType) => {
        setSelectedType(reportType);
        // if (reportType === "accountLedger") {
        //     let year = moment().year();
        //     let firstDay;
        //     if (moment().month() <= 4)
        //         firstDay = moment.utc(`${moment().year() - 1}/04/01`);
        //     else
        //         firstDay = moment.utc(`${moment().year()}/04/01`);
        //     form.setFieldsValue({ startDate: dayjs(firstDay), endDate: dayjs() })
        // }
    }

    return (
        <Space direction='vertical' size={24} style={{ width: "100%" }}>
            <Typography.Title level={5}>Reports</Typography.Title>
            <Card>
                <Form
                    layout="vertical"
                    form={form}
                    initialValues={{
                        startDate: moment().month() <= 2 ?
                            dayjs(moment.utc(`${moment().year() - 1}/04/01`)) :
                            dayjs(moment.utc(`${moment().year()}/04/01`)),
                        endDate: dayjs()
                    }}
                >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name="reportType"
                                label="Type"
                                rules={[{ required: true, message: "Type is required." }]}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                                        0
                                    }
                                    onChange={onChangeReportType}
                                >
                                    {REPORT_TYPES.map((option) => (
                                        <Select.Option key={option.key} value={option.key}>
                                            {option.value}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        {(selectedType === "accountLedger" || selectedType === "partywiseRO" || selectedType === "partywiseTDS" || selectedType === "accountwiseRO") && <Col span={8}>
                            <Form.Item
                                name="accountId"
                                label="Account"
                                rules={[{ required: true, message: "Account is required." }]}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                                        0
                                    }
                                >
                                    {account.map((option) => (
                                        <Select.Option key={option.id} value={option.id}>
                                            {option.accountName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>}
                        {selectedType !== "outstandingBalance" && <>
                            <Col span={8}>
                                <Form.Item
                                    name="startDate"
                                    label="Start Date"
                                    rules={[{ required: true, message: "Start Date is required." }]}
                                >
                                    <DatePicker format={DEFAULT_DATE_FORMAT} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    name="endDate"
                                    label="End Date"
                                    rules={[{ required: true, message: "End Date is required." }]}
                                >
                                    <DatePicker format={DEFAULT_DATE_FORMAT} />
                                </Form.Item>
                            </Col>
                        </>}
                    </Row>
                    <Row style={{ float: "right" }}>
                        <Col span={24}>
                            <Space>
                                <Button type='primary' loading={processing} onClick={onSubmit}>View/Download Report</Button>
                                <Button type='default' onClick={onClear}>Clear</Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Card>

            {visiblePrint && (
                <ReportPdfModal
                    visible={visiblePrint}
                    data={tableData}
                    title={selectedType}
                    close={handlePrint}
                    pdfType={selectedType}
                    dates={form.getFieldsValue()}
                />
            )}
        </Space>
    );
}

export default Report;